import * as moment from 'moment'

export const dateToTransport = (date: string): string => {
  return moment(date).format()
}
// time 23:11  lub 4:59
export const parseTime = (
  time: string,
  separator: string = ':',
): { hour: number; minute: number } => {
  if (time.indexOf(separator)) {
    const a = time.split(':')
    const hour = parseInt(a[0], 10)
    const minute = parseInt(a[1], 10)
    return { hour, minute }
  }

  return { hour: 0, minute: 0 }
}
